import {
  type NotificationsFormValues,
  type OrderArrivedFormFields,
  type OrderShippedFormFields,
} from '~/types/EmailNotifications';

import { ActionKeys } from './constants';

export const fetchNotifications = () =>
  <const>{
    type: ActionKeys.FETCH_NOTIFICATIONS,
  };

export const fetchNotificationsSuccess = (payload: NotificationsFormValues) =>
  <const>{
    payload,
    type: ActionKeys.FETCH_NOTIFICATIONS_SUCCESS,
  };

export const fetchNotificationsError = (errorMessage) =>
  <const>{
    payload: {
      errorMessage,
    },
    type: ActionKeys.FETCH_NOTIFICATIONS_ERROR,
  };

export const updateOrderShippedEmailSettings = (orderShippedFormFields: OrderShippedFormFields) =>
  <const>{
    payload: {
      orderShippedFormFields,
    },
    type: ActionKeys.UPDATE_ORDER_SHIPPED_EMAIL_SETTINGS,
  };

export const updateOrderShippedEmailSettingsSuccess = (
  orderShippedFormFields: OrderShippedFormFields,
) =>
  <const>{
    payload: {
      orderShippedFormFields,
    },
    type: ActionKeys.UPDATE_ORDER_SHIPPED_EMAIL_SETTINGS_SUCCESS,
  };

export const updateOrderShippedEmailSettingsError = (errorData) =>
  <const>{
    payload: {
      errorData,
    },
    type: ActionKeys.UPDATE_ORDER_SHIPPED_EMAIL_SETTINGS_ERROR,
  };

export const updateOrderArrivedEmailSettings = (orderArrivedFormFields: OrderArrivedFormFields) =>
  <const>{
    payload: {
      orderArrivedFormFields,
    },
    type: ActionKeys.UPDATE_ORDER_ARRIVED_EMAIL_SETTINGS,
  };

export const updateOrderArrivedEmailSettingsSuccess = (
  orderArrivedFormFields: OrderArrivedFormFields,
) =>
  <const>{
    payload: {
      orderArrivedFormFields,
    },
    type: ActionKeys.UPDATE_ORDER_ARRIVED_EMAIL_SETTINGS_SUCCESS,
  };

export const updateOrderArrivedEmailSettingsError = (errorData) =>
  <const>{
    payload: {
      errorData,
    },
    type: ActionKeys.UPDATE_ORDER_ARRIVED_EMAIL_SETTINGS_ERROR,
  };

export const sendSampleEmail = (notificationType: string) =>
  <const>{
    notificationType,
    type: ActionKeys.SEND_SAMPLE_EMAIL,
  };

export const sendSampleEmailSuccess = (notificationType: string) =>
  <const>{
    notificationType,
    type: ActionKeys.SEND_SAMPLE_EMAIL_SUCCESS,
  };

export const sendSampleEmailError = (notificationType: string) =>
  <const>{
    notificationType,
    type: ActionKeys.SEND_SAMPLE_EMAIL_ERROR,
  };

export const clearSampleEmailErrors = () =>
  <const>{
    type: ActionKeys.CLEAR_SAMPLE_EMAIL_ERRORS,
  };

export type NotificationsActions =
  | ReturnType<typeof clearSampleEmailErrors>
  | ReturnType<typeof fetchNotifications>
  | ReturnType<typeof fetchNotificationsError>
  | ReturnType<typeof fetchNotificationsSuccess>
  | ReturnType<typeof sendSampleEmail>
  | ReturnType<typeof sendSampleEmailError>
  | ReturnType<typeof sendSampleEmailSuccess>
  | ReturnType<typeof updateOrderArrivedEmailSettings>
  | ReturnType<typeof updateOrderArrivedEmailSettingsError>
  | ReturnType<typeof updateOrderArrivedEmailSettingsSuccess>
  | ReturnType<typeof updateOrderShippedEmailSettings>
  | ReturnType<typeof updateOrderShippedEmailSettingsError>
  | ReturnType<typeof updateOrderShippedEmailSettingsSuccess>;
